module.exports = __webpack_public_path__ + "static/media/US-CA.824e38fe.svg";